import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export const MAIN_CLASS = 'mobile-table';
export const CLASSNAMES = {
  table: `${MAIN_CLASS}__table`,
  tableHeader: `${MAIN_CLASS}__header`,
  tableBody: `${MAIN_CLASS}__body`,
  tableRow: `${MAIN_CLASS}__row`,
  tableRowClickable: `${MAIN_CLASS}__row--clickable`,
  tableCell: `${MAIN_CLASS}__cell`,
  cellContent: `${MAIN_CLASS}__cell-content`,
  noResultsMessage: `${MAIN_CLASS}__no-results-message`,
  tooltipContentWrapper: `${MAIN_CLASS}__tooltip-content-wrapper`,
};
// @ts-ignore
export default css({
  fontSize: theme.fontSizes[1],
  width: '99%',
  margin: '0 auto',
  overflowX: 'auto',
  overflowY: 'hidden',
  '& thead': {
    borderBottom: `1px solid ${COLORS.NEUTRAL300}`,
  },
  [`.${MAIN_CLASS}`]: {
    '&__table': {
      height: 'min-content',
      width: '100%',
      tableLayout: 'fixed',
      overflow: 'hidden',
    },
    '&__header': {
      color: COLORS.NEUTRAL600,
      ...theme.text.category,
    },
    '&__header::before': {
      content: "''",
      paddingRight: '8px',
    },
    '&__header:last-of-type::after': {
      width: '100%',
    },
    '&__body': {
      ...theme.text.caption,
      fontSize: theme.fontSizes[2],
    },
    '&__row': {
      borderBottom: `2px solid ${COLORS.NEUTRAL100}`,
      [mediaquery.md]: {
        '&--clickable:hover': {
          cursor: 'pointer',
          background: COLORS.PRIMARY100,
        },
      },
    },
    '&__cell': {
      padding: '10px 0 10px 8px',
    },
    '&__cell-content': {
      margin: 0,
      whiteSpace: 'nowrap',
      wordBreak: 'break-word',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      height: '100%',
      lineHeight: '150%',
      userSelect: 'none',
      [mediaquery.md]: {
        userSelect: 'auto',
      },
    },
    '&__no-results-message': {
      textAlign: 'center',
      padding: '10px',
    },
    '&__tooltip-content-wrapper': {
      maxWidth: '50vw',
      wordBreak: 'break-all',
    },
  },
  '.tippy': {
    whiteSpace: 'nowrap',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  // --- Sort + filter affordances in column headers ----------------------
  '.brkfst-table__header-content': {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  '.brkfst-table__sort-trigger': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': { color: COLORS.NEUTRAL700 },
  },
  '.brkfst-table__sort-trigger--active': {
    color: COLORS.NEUTRAL700,
  },
  '.brkfst-table__sort-icon': {
    flexShrink: 0,
  },
  '.brkfst-table__filter-trigger': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    borderRadius: '3px',
    '&:hover': { background: COLORS.NEUTRAL100 },
  },
  '.brkfst-table__filter-trigger--active': {
    background: COLORS.PRIMARY100,
  },

  // --- Selected row tint -----------------------------------------------
  [`.${MAIN_CLASS}__row.brkfst-table__row--selected`]: {
    background: COLORS.PRIMARY100,
  },

  // --- Filter popover body --------------------------------------------
  '.brkfst-table__filter-popover': {
    minWidth: '220px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  '.brkfst-table__filter-label': {
    color: COLORS.NEUTRAL600,
    fontSize: theme.fontSizes[1],
    fontWeight: 600,
  },
  '.brkfst-table__filter-mode-row': {
    flexDirection: 'column',
    gap: '4px',
  },
  '.brkfst-table__filter-mode': {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
    fontSize: theme.fontSizes[2],
  },
  '.brkfst-table__filter-input': {
    width: '100%',
    padding: '6px 8px',
    border: `1px solid ${COLORS.NEUTRAL300}`,
    borderRadius: '4px',
    fontSize: theme.fontSizes[2],
  },
  '.brkfst-table__filter-actions': {
    justifyContent: 'flex-end',
    gap: '8px',
    marginTop: '4px',
  },
  '.brkfst-table__filter-shortcuts': {
    justifyContent: 'space-between',
    gap: '8px',
    marginBottom: '4px',
  },
  '.brkfst-table__filter-options': {
    maxHeight: '180px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '4px 0',
    borderTop: `1px solid ${COLORS.NEUTRAL200}`,
    borderBottom: `1px solid ${COLORS.NEUTRAL200}`,
  },
  '.brkfst-table__filter-option': {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
    fontSize: theme.fontSizes[2],
    '& > span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  '.brkfst-table__filter-empty': {
    fontSize: theme.fontSizes[1],
    color: COLORS.NEUTRAL500,
    padding: '4px 0',
  },
});
